import WorkReportConstants from '../constants/work-report-constants';

// const dataStatus = ["unload", "loading", "loaded", "error", "reload"];

const initState = {

	// my daily report
	dailyReportFilters: {
		start_date: "",
		end_date: "",
		status: false,
		type_id: 1,
		page: 1
	},
	dailyReportLoadCounter: 0,
	dailyReportData: [],
	dailyReportStatus: "unload",

	// daily report management
	leaderDailyReportFilters: {
		real_name: "",
		code: "",
		start_date: "",
		end_date: "",
		status: false,
		type_id: 1,
		page: 1
	},
	leaderDailyReportLoadCounter: 0,
	leaderDailyReportData: [],
	leaderDailyReportStatus: "unload",

	// my weekly report
	weeklyReportFilters: {
		start_date: "",
		end_date: "",
		status: false,
		type_id: 2,
		page: 1
	},
	weeklyReportLoadCounter: 0,
	weeklyReportData: [],
	weeklyReportStatus: "unload",

	
	// weekly question summary report
	weeklyQuestionSummaryFilters: {
		start_date: "",
		end_date: "",
		status: false,
		type_id: 2,
		page: 1
	},
	weeklyQuestionSummaryLoadCounter: 0,
	weeklyQuestionSummaryData: [],
	weeklyQuestionSummaryStatus: "unload",

	// weekly report management
	leaderWeeklyReportFilters: {
		real_name: "",
		code: "",
		start_date: "",
		end_date: "",
		status: false,
		type_id: 2,
		page: 1
	},
	leaderWeeklyReportLoadCounter: 0,
	leaderWeeklyReportData: [],
	leaderWeeklyReportStatus: "unload",

	// my monthly report
	monthlyReportFilters: {
		start_date: "",
		end_date: "",
		status: false,
		type_id: 3,
		page: 1
	},
	monthlyReportLoadCounter: 0,
	monthlyReportData: [],
	monthlyReportStatus: "unload",

	// monthly report management
	leaderMonthlyReportFilters: {
		real_name: "",
		code: "",
		start_date: "",
		end_date: "",
		status: false,
		type_id: 3,
		page: 1
	},
	leaderMonthlyReportLoadCounter: 0,
	leaderMonthlyReportData: [],
	leaderMonthlyReportStatus: "unload",
	
	// template management
	templateManagement: {
		filters: {
			page: 1
		},
		data: [],
		dataStaus: "unload",
		loadCounter: 0
	}
}

export default function workReport(state = initState, action) {
	switch (action.type) {

		// my daily report
		case WorkReportConstants.ActionTypes.INCREASEDAILYREPORTLOADCOUNTER:
			return { 
				...state,
				dailyReportLoadCounter: state.dailyReportLoadCounter + 1
			};
		case WorkReportConstants.ActionTypes.SELECTDAILYREPORTSUCCESS:
			return {
				...state,
				dailyReportData: action.payload.data,
				dailyReportStatus: "loaded"
			};
		case WorkReportConstants.ActionTypes.SETDAILYREPORTFILTERS:
			return { 
				...state,
				dailyReportLoadCounter: state.dailyReportLoadCounter + 1,
				dailyReportFilters: { 
					...state.dailyReportFilters,
					...action.payload.filters
				}
			};
		case WorkReportConstants.ActionTypes.UPDATEDAILYREPORTSUCCESS:
			let copyDailyReportState = { ...state };
			copyDailyReportState.dailyReportData.Data[action.payload.index] = action.payload.value;
			return copyDailyReportState;
		case WorkReportConstants.ActionTypes.UPDATEDAILYREPORTSTATUSSUCCESS:
			return {	
				...state,
				dailyReportStatus: action.payload.status
			};

		// daily report management
		case WorkReportConstants.ActionTypes.INCREASELEADERDAILYREPORTLOADCOUNTER:
			return {
				...state,
				leaderDailyReportLoadCounter: state.leaderDailyReportLoadCounter + 1
			};
		case WorkReportConstants.ActionTypes.SELECTLEADERDAILYREPORTSUCCESS:
			return {
				...state,
				leaderDailyReportData: action.payload.data,
				leaderDailyReportStatus: "loaded"
			};
		case WorkReportConstants.ActionTypes.SETLEADERDAILYREPORTFILTERS:
			return {
				...state,
				leaderDailyReportLoadCounter: state.leaderDailyReportLoadCounter + 1,
				leaderDailyReportFilters: { 
					...state.leaderDailyReportFilters,
					...action.payload.filters
				}
			};
		case WorkReportConstants.ActionTypes.UPDATELEADERDAILYREPORTSTATUSSUCCESS:
			return {
				...state,
				leaderDailyReportStatus: action.payload.status

			};
		// weekly question summary

		case WorkReportConstants.ActionTypes.SELECTWEEKLYQUESTIONSUMMARYSUCCESS:
			return {
				...state,
				weeklyQuestionSummaryData: action.payload.data,
				weeklyQuestionSummaryStatus: "loaded"
			};
		case WorkReportConstants.ActionTypes.INCREASEWEEKLYQUESTIONSUMMARYLOADCOUNTER:
			return {
				...state,
				weeklyQuestionSummaryLoadCounter: state.weeklyQuestionSummaryLoadCounter + 1
			};
		case WorkReportConstants.ActionTypes.SETWEEKLYQUESTIONSUMMARYFILTERS:
			return {
				...state,
				weeklyQuestionSummaryLoadCounter: state.weeklyQuestionSummaryLoadCounter + 1,
				weeklyQuestionSummaryFilters: { 
					...state.weeklyQuestionSummarytFilters,
					...action.payload.filters
				}
			};
			
			case WorkReportConstants.ActionTypes.UPDATEWEEKLYQUESTIONSUMMARYSTATUSSUCCESS:
				return {
					...state,
					weeklyQuestionSummaryStatus: action.payload.status
				};
		
		// my weekly report
		case WorkReportConstants.ActionTypes.INCREASEWEEKLYREPORTLOADCOUNTER:
			return {
				...state,
				weeklyReportLoadCounter: state.weeklyReportLoadCounter + 1
			};
		case WorkReportConstants.ActionTypes.SELECTWEEKLYREPORTSUCCESS:
			return {
				...state,
				weeklyReportData: action.payload.data,
				weeklyReportStatus: "loaded"
			};
		case WorkReportConstants.ActionTypes.SETWEEKLYREPORTFILTERS:
			return {
				...state,
				weeklyReportLoadCounter: state.weeklyReportLoadCounter + 1,
				weeklyReportFilters: { 
					...state.weeklyReportFilters,
					...action.payload.filters
				}
			};
		case WorkReportConstants.ActionTypes.UPDATEWEEKLYREPORTSUCCESS:
			let copyWeeklyReportState = { ...state };
			copyWeeklyReportState.weeklyReportData.Data[action.payload.index] = action.payload.value;
			return copyWeeklyReportState;

		// weekly report management
		case WorkReportConstants.ActionTypes.INCREASELEADERWEEKLYREPORTLOADCOUNTER:
			return {
				...state,
				leaderWeeklyReportLoadCounter: state.leaderWeeklyReportLoadCounter + 1
			};
		case WorkReportConstants.ActionTypes.SELECTLEADERWEEKLYREPORTSUCCESS:
			return {
				...state,
				leaderWeeklyReportData: action.payload.data,
				leaderWeeklyReportStatus: "loaded"
			};
		case WorkReportConstants.ActionTypes.SETLEADERWEEKLYREPORTFILTERS:
			return {
				...state,
				leaderWeeklyReportLoadCounter: state.leaderWeeklyReportLoadCounter + 1,
				leaderWeeklyReportFilters: { 
					...state.leaderWeeklyReportFilters,
					...action.payload.filters
				}
			};
		case WorkReportConstants.ActionTypes.UPDATELEADERWEEKLYREPORTSTATUSSUCCESS:
			return {
				...state,
				leaderWeeklyReportStatus: action.payload.status
			};

		// my monthly report
		case WorkReportConstants.ActionTypes.INCREASEMONTHLYREPORTLOADCOUNTER:
			return { 
				...state,
				monthlyReportLoadCounter: state.monthlyReportLoadCounter + 1
			};
		case WorkReportConstants.ActionTypes.SELECTMONTHLYREPORTSUCCESS:
			return {
				...state,
				monthlyReportData: action.payload.data,
				monthlyReportStatus: "loaded"
			};
		case WorkReportConstants.ActionTypes.SETMONTHLYREPORTFILTERS:
			return { 
				...state,
				monthlyReportLoadCounter: state.monthlyReportLoadCounter + 1,
				monthlyReportFilters: { 
					...state.monthlyReportFilters,
					...action.payload.filters
				}
			};
		case WorkReportConstants.ActionTypes.UPDATEMONTHLYREPORTSUCCESS:
			let copyMonthlyReportState = { ...state };
			copyMonthlyReportState.monthlyReportData.Data[action.payload.index] = action.payload.value;
			return copyMonthlyReportState;
		case WorkReportConstants.ActionTypes.UPDATEMONTHLYREPORTSTATUSSUCCESS:
			return {
				...state,
				monthlyReportStatus: action.payload.status
			};

		// monthly report management
		case WorkReportConstants.ActionTypes.INCREASELEADERMONTHLYREPORTLOADCOUNTER:
			return {
				...state,
				leaderMonthlyReportLoadCounter: state.leaderMonthlyReportLoadCounter + 1
			};
		case WorkReportConstants.ActionTypes.SELECTLEADERMONTHLYREPORTSUCCESS:
			return {
				...state,
				leaderMonthlyReportData: action.payload.data,
				leaderMonthlyReportStatus: "loaded"
			};
		case WorkReportConstants.ActionTypes.SETLEADERMONTHLYREPORTFILTERS:
			return {
				...state,
				leaderMonthlyReportLoadCounter: state.leaderMonthlyReportLoadCounter + 1,
				leaderMonthlyReportFilters: { 
					...state.leaderMonthlyReportFilters,
					...action.payload.filters
				}
			};
		case WorkReportConstants.ActionTypes.UPDATELEADERMONTHLYREPORTSTATUSSUCCESS:
			return {
				...state,
				leaderMonthlyReportStatus: action.payload.status
			};

		// template management
		case WorkReportConstants.ActionTypes.CHANGETEMPLATEMANAGEMENT:
			return {
				...state,
				templateManagement: {
					...state.templateManagement,
					filters: {
						...state.templateManagement.filters,
						...action.payload.filters
					},
					dataStatus: action.payload.status,
					loadCounter: state.templateManagement.loadCounter + action.payload.counter
				}
			}

		case WorkReportConstants.ActionTypes.SELECTTEMPLATEMANAGEMENT:
			return {
				...state,
				templateManagement: {
					...state.templateManagement,
					data: action.payload.data,
					dataStatus: action.payload.status
				}
			}

		case WorkReportConstants.ActionTypes.UPDATETEMPLATEMANAGEMENT:
			return {
				...state,
				templateManagement: {
					...state.templateManagement,
					data: {
						...state.templateManagement.data,
						Data: [
							...state.templateManagement.data.Data.slice(0, action.payload.index),
							action.payload.data,
							...state.templateManagement.data.Data.slice(action.payload.index + 1)
						]
					}
				}
			}
		default :
		 return state;
	}
}




// WEBPACK FOOTER //
// ./src/reducers/work-report-reducer.js